/**
 * Lightweight page-load timing utility.
 * Usage:
 *   perf.markStart('warehouse-page');
 *   // ... after data loaded ...
 *   perf.markEnd('warehouse-page');   // logs duration
 *   perf.getReport();                 // returns all timings
 */

const marks = {};
const completed = [];

export const perf = {
  markStart(label) {
    marks[label] = performance.now();
  },

  markEnd(label) {
    const start = marks[label];
    if (start == null) return null;
    const duration = Math.round(performance.now() - start);
    delete marks[label];
    const entry = { label, duration, ts: new Date().toISOString() };
    completed.push(entry);
    if (completed.length > 50) completed.shift();
    if (process.env.NODE_ENV !== 'production') {
      console.log(`[perf] ${label}: ${duration}ms`);
    }
    return duration;
  },

  getReport() {
    return [...completed];
  },

  clear() {
    completed.length = 0;
  },
};
